/* this file is transformed by vux-loader */
/* eslint-disable */
import request from '../request';
/**
 * @description test
 */

export function hdprofileInfo() {
  return request.get("/hd/hdprofile/info");
}